export default "__VITE_ASSET__DpC8Ry7B__"